import styled from '@emotion/styled';
import { Paper, TableContainer, TableHead, TableRow } from '@mui/material';

export const AdminPageWrapper = styled.div`
  min-height: 100vh;
  width: 100%;
  padding: 2rem;
  box-sizing: border-box;
  overflow-x: hidden;
  background:
    radial-gradient(circle at top right, rgba(99, 102, 241, 0.25), transparent 45%),
    radial-gradient(circle at 20% 20%, rgba(59, 130, 246, 0.15), transparent 40%),
    linear-gradient(180deg, rgba(240, 242, 255, 0.7) 0%, rgba(247, 250, 255, 0.95) 100%);

  @media (max-width: 768px) {
    padding: 1rem;
    min-height: calc(100vh - var(--app-header-height));
  }
`;

export const DashboardContainer = styled.div`
  max-width: 1400px;
  margin: 0 auto;
  width: 100%;
  box-sizing: border-box;
`;

export const GlassCard = styled(Paper)`
  background: rgba(255, 255, 255, 0.7);
  backdrop-filter: blur(20px);
  border: 1px solid rgba(255, 255, 255, 0.5);
  border-radius: 24px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.05);
  padding: 24px;
  transition:
    transform 0.2s ease,
    box-shadow 0.2s ease;
  overflow: hidden;

  &.MuiPaper-root {
    background: rgba(255, 255, 255, 0.75);
  }

  @media (max-width: 768px) {
    padding: 16px;
    border-radius: 16px;
  }
`;

export const SectionTitle = styled.h2`
  font-family: 'Inter', sans-serif;
  font-size: 1.5rem;
  font-weight: 700;
  color: #1f2937;
  margin-bottom: 1.5rem;
  display: flex;
  align-items: center;
  gap: 10px;

  &::before {
    content: '';
    display: block;
    width: 6px;
    height: 24px;
    background: linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%);
    border-radius: 10px;
  }

  @media (max-width: 768px) {
    font-size: 1.25rem;
    margin-bottom: 1rem;

    &::before {
      height: 20px;
    }
  }
`;

export const TableWrapper = styled.div`
  width: 100%;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  margin-bottom: 20px;
  border-radius: 16px;

  @media (max-width: 768px) {
    margin-left: -16px;
    margin-right: -16px;
    width: calc(100% + 32px);
    border-radius: 0;
  }
`;

export const StyledTableContainer = styled(TableContainer)`
  border-radius: 16px;
  background: transparent;
  box-shadow: none;
  min-width: 800px;

  & .MuiTable-root {
    border-collapse: separate;
    border-spacing: 0 8px;
  }

  @media (max-width: 768px) {
    border-radius: 0;
    min-width: 600px;

    & .MuiTable-root {
      border-spacing: 0 4px;
    }
  }
`;

export const StyledTableHead = styled(TableHead)`
  & .MuiTableCell-root {
    background: transparent;
    color: #6b7280;
    font-weight: 600;
    text-transform: uppercase;
    font-size: 0.75rem;
    letter-spacing: 0.05em;
    border-bottom: none;
    padding: 16px;

    @media (max-width: 768px) {
      padding: 12px 8px;
      font-size: 0.7rem;
    }
  }
`;

export const StyledTableRow = styled(TableRow)`
  background: white;
  transition: all 0.2s ease;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.02);

  & td:first-of-type {
    border-top-left-radius: 12px;
    border-bottom-left-radius: 12px;
  }

  & td:last-of-type {
    border-top-right-radius: 12px;
    border-bottom-right-radius: 12px;
  }

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 16px rgba(99, 102, 241, 0.1);
    background: #f8fafc;
  }

  & .MuiTableCell-root {
    border-bottom: none;
    padding: 16px;
    font-size: 0.95rem;
    color: #374151;

    @media (max-width: 768px) {
      padding: 12px 8px;
      font-size: 0.85rem;
    }
  }
`;

export const ActionIconButton = styled.button`
  background: #f3f4f6;
  border: none;
  width: 36px;
  height: 36px;
  border-radius: 10px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #6b7280;
  cursor: pointer;
  transition: all 0.2s ease;
  margin-right: 8px;

  &:hover {
    background: #e0e7ff;
    color: #6366f1;
    transform: scale(1.05);
  }

  &:last-of-type {
    margin-right: 0;
  }

  @media (max-width: 768px) {
    width: 32px;
    height: 32px;
    margin-right: 4px;
  }
`;
